import React from "react";
import { Mail, ExternalLink } from "lucide-react";

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#FFFEF5] border-t-4 border-black">
      {/* CTA Section */}
      <div className="bg-yellow-400 border-b-4 border-black">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h2 className="text-2xl md:text-3xl font-black mb-2">
                店舗開設のご相談はこちら
              </h2>
              <p className="text-gray-800">
                オリパサイト開設に関するご質問、お気軽にどうぞ。
              </p>
            </div>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 px-8 py-4 bg-black text-white font-black text-lg border-4 border-black shadow-[4px_4px_0px_0px_rgba(255,255,255,1)] hover:shadow-[2px_2px_0px_0px_rgba(255,255,255,1)] hover:translate-x-[2px] hover:translate-y-[2px] transition-all"
            >
              <Mail className="w-5 h-5" />
              お問い合わせ
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <a href="/" className="inline-block group">
              <span className="text-2xl font-black tracking-tight">
                <span className="text-black">JOY</span>
                <span className="relative">
                  <span className="text-black">BASE</span>
                  <span className="absolute -bottom-1 left-0 w-full h-1 bg-yellow-400 group-hover:h-2 transition-all"></span>
                </span>
              </span>
            </a>
            <p className="mt-4 text-sm text-gray-600">
              カードゲーム店舗向け<br />
              オリパ販売プラットフォーム
            </p>
            {/* Social Links */}
            <div className="mt-4 flex gap-3">
              <a
                href="https://x.com/joybasejp"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-black text-white border-2 border-black flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://note.com/joybase"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-black text-white border-2 border-black flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-colors font-black text-xs"
              >
                note
              </a>
              {/* LINE link temporarily hidden
              <a
                href="https://lin.ee/9uCjZT1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#06C755] text-white border-2 border-black flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-colors"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63h2.386c.349 0 .63.285.63.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63.349 0 .631.285.631.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.281.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
                </svg>
              </a>
              */}
            </div>
          </div>

          {/* Links Columns */}
          <div>
            <h3 className="font-black text-sm mb-4 pb-2 border-b-4 border-yellow-400 inline-block">
              サービス
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="/features" className="text-gray-700 hover:text-black hover:font-bold transition-all">
                  特徴
                </a>
              </li>
              <li>
                <a href="/pricing" className="text-gray-700 hover:text-black hover:font-bold transition-all">
                  料金
                </a>
              </li>
              <li>
                <a href="/for_shops/how-to-start" className="text-gray-700 hover:text-black hover:font-bold transition-all">
                  始め方
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-black text-sm mb-4 pb-2 border-b-4 border-green-400 inline-block">
              サポート
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="/faq" className="text-gray-700 hover:text-black hover:font-bold transition-all">
                  よくある質問
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-700 hover:text-black hover:font-bold transition-all">
                  お問い合わせ
                </a>
              </li>
              <li>
                <a href="https://joybase.jp/blog/" className="text-gray-700 hover:text-black hover:font-bold transition-all flex items-center gap-1">
                  ブログ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-black text-sm mb-4 pb-2 border-b-4 border-blue-400 inline-block">
              企業情報
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://codingholic.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-black hover:font-bold transition-all flex items-center gap-1"
                >
                  運営会社
                  <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>

          </div>
        </div>

        {/* Legal Links */}
        <div className="mt-12 pt-8 border-t-4 border-black">
          <div className="flex flex-wrap gap-4 text-xs font-bold">
            <a href="/terms" className="text-gray-600 hover:text-black transition-colors">
              利用規約
            </a>
            <span className="text-gray-300">|</span>
            <a href="/trade-law" className="text-gray-600 hover:text-black transition-colors">
              特定商取引法に基づく表記
            </a>
            <span className="text-gray-300">|</span>
            <a href="/privacy" className="text-gray-600 hover:text-black transition-colors">
              プライバシーポリシー
            </a>
          </div>

          <p className="mt-6 text-xs text-gray-500 font-bold">
            &copy; {new Date().getFullYear()} JOYBASE. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
